import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { Component } from "react";
import { Col, Label, Row } from "reactstrap";
import PtsAlert from "../ptsAlert/PtsAlert";
import Utils from "../../../provider/Utils";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
class AddressWithTimezone extends Component {
  countryListArray = store.getState().staticData.countryList;
  stateListArray = [];
  defaultCountry = store.getState().staticData.defaultCountry;
  timeZoneListArray = [];
  constructor(props) {
    super(props);
    let address = props.data;
    let action = props.action;
    let pageId = props.pageId;
    if (props.state) {
      action = props.state.action;
      pageId = props.state.pageId;
    }
    if (action && Utils.equalsIgnoreCase(action, "create")) {
      this.state = {
        id: "",
        line: "",
        country: this.defaultCountry,
        state: null,
        city: "",
        zipCode: "",
        timeZone: null,
        orgTimeZone: null,
        pageId: pageId,
        action: this.props.action,
        onChange: this.props.onChange,
        render: true,
        zipCodeErrorMessageText: "",
      };
      this.handleCountryChange(this.defaultCountry);
    } else {
      if (address) {
        this.state = {
          id: address.id ? address.id : "",
          line: address.line ? address.line : "",
          state: address.state ? address.state : "",
          selectedState: address.state ? address.state : null,
          country: address.state ? address.state.country : "",
          city: address.city ? address.city : "",
          zipCode: address.zipcode ? address.zipcode : "",
          timeZone: address.state ? address.state.country?.timezones : "",
          stateClear: false,
          action: this.props.action,
          onChange: this.props.onChange,
          orgTimeZone: this.props.timeZone,
          pageId: pageId,
          render: true,
          zipCodeErrorMessageText: "",
        };
        let country = {};
        if (address.state?.country) {
          country = address.state?.country;
        } else {
          country = this.defaultCountry;
        }
        this.handleCountryChange(country);
      } else {
        this.state = {
          id: "",
          line: "",
          country: this.defaultCountry,
          state: null,
          city: "",
          zipCode: "",
          timeZone: null,
          orgTimeZone: this.props.timeZone,
          pageId: pageId,
          action: this.props.action,
          onChange: this.props.onChange,
          render: true,
          zipCodeErrorMessageText: "",
        };
        this.handleCountryChange(this.defaultCountry);
      }
    }
  }
  getCountryList() {
    FetchServerData.callPostService("/countryms/get", {}).then((output) => {
      if (output.status === "SUCCESS") {
        this.countryListArray = output.data;
        this.setState({
          render: true,
        });
      } else {
      }
    });
  }

  setStatesForCountry(selectedCountry) {
    this.setState({
      country: selectedCountry,
      selectedCountry: selectedCountry,
    });
  }

  handleStateChange(selectedState) {
    this.state.state = selectedState;
    this.setState({ state: selectedState });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleTimeZoneChange(selectedTimezone) {
    this.state.timeZone = selectedTimezone;
    this.setState({
      timeZone: selectedTimezone,
      orgTimeZone: selectedTimezone,
    });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleLine1Change(e) {
    let val = e.target.value;
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ line: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handleLine2Change(e) {
    this.setState({ line2: e.target.value });
  }

  handleCityChange(e) {
    let val = Utils.toCamelCase(e.target.value);
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ city: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handlePinCodeChange(e) {
    let val = e.target.value;
    if (Utils.equalsIgnoreCase(this.state.country?.name, "Canada")) {
      let res = val.substring(0, 6);
      if (res.length < 7) {
        this.setState({ zipCode: res, zipCodeErrorMessageText: "" });
      } else {
        this.setState({
          zipCodeErrorMessageText:
            "The size of this field is limited to 5 characters only",
        });
      }
    } else {
      let res = val.substring(0, 5);
      if (res.length < 6) {
        this.setState({ zipCode: res, zipCodeErrorMessageText: "" });
      } else {
        this.setState({
          zipCodeErrorMessageText:
            "The size of this field is limited to 5 characters only",
        });
      }
    }
  }

  handleCountryChange(selectedCountry) {
    if (null === selectedCountry || selectedCountry === "") {
      this.stateListArray = [];
      this.setState({
        stateClear: !this.state.stateClear,
      });
      return;
    }
    this.state.country = selectedCountry;
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }

    this.setState({
      country: selectedCountry,
      state: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry?.id },
    };
    FetchServerData.callPostService("/countryms/get", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;

          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }

  validateAddress() {
    if (Utils.isNullOrEmpty(this.state.country)) {
      document.getElementById("country").focus();
      PtsAlert.error("Please Select Country");

      return false;
    }
    if (Utils.isNullOrEmpty(this.state.state)) {
      document.getElementById("state").focus();
      PtsAlert.error("Please Select State");
      return false;
    }
    if (Utils.isNullOrEmpty(this.state.timeZone)) {
      document.getElementById("timeZone").focus();
      PtsAlert.error("Please Select Timezone");
      return false;
    }

    return true;
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      this.countryRef = React.createRef();
      this.stateRef = React.createRef();
      if (this.props.action === "create") {
        return this.createAddress();
      } else if (this.props.action === "edit") {
        return this.editAddress();
      } else {
        return this.viewAddress();
      }
    }
  }
  editAddress() {
    return (
      <>
        <div className="row">
          <div className="col-md-12" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-companyName">
              Street Address
            </label>
            <input
              type="text"
              autoComplete="off"
              id="multiStepsFirstName"
              name="multiStepsFirstName"
              className="form-control"
              onChange={this.handleLine1Change.bind(this)}
              value={this.state.line}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              City*
            </label>
            <input
              title=""
              required
              type="text"
              autoComplete="off"
              id="multiStepsFirstName"
              name="multiStepsFirstName"
              className="form-control"
              value={this.state.city}
              onChange={this.handleCityChange.bind(this)}
              onBlur={() => {
                this.props.onChange(this.state);
              }}
            />
          </div>
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="multiStepsState">
              State/Province/Region*
            </label>
            <Autocomplete
              id="size-small-outlined"
              size="small"
              fullWidth
              disableClearable
              autoComplete="off"
              ListboxProps={{
                className: "custom-listbox",
              }}
              options={this.stateListArray}
              value={this.state.state ? this.state.state : null}
              getOptionLabel={(option) => option.namecode}
              defaultValue={this.state.state}
              onChange={(event, value) => {
                this.handleStateChange(value);
              }}
              inputprops={{ style: { textTransform: "capitalize" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Please Select"
                  variant="outlined"
                  size="small"
                  className="textField"
                  required
                  title=""
                  style={{ background: "#fff" }}
                />
              )}
            />
          </div >
        </div >
        <div className="row mt-3">
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              Zip/Postal Code*
            </label>
            <input
              type="text"
              autoComplete="off"
              id="multiStepsLastName"
              className="form-control"
              value={this.state.zipCode}
              onChange={this.handlePinCodeChange.bind(this)}
              inputprops={{ maxLength: 16 }}
              onBlur={() => {
                this.props.onChange(this.state);
              }}
              name="zipCode"
            />
            {this.state.zipCodeErrorMessageText && (
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                }}
              >
                {this.state.zipCodeErrorMessageText}
              </p>
            )}
          </div>
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              Country
              *
            </label>
            <Autocomplete
              id="size-small-outlined"
              size="small"
              fullWidth
              disableClearable
              autoComplete="off"
              ListboxProps={{
                className: "custom-listbox",
              }}
              options={this.countryListArray}
              value={
                this.state.country ? this.state.country : this.defaultCountry
              }
              defaultValue={this.state.select}
              getOptionLabel={(option) => option.namecode}
              onChange={(event, value) => {
                this.handleCountryChange(value);
              }}
              inputprops={{ style: { textTransform: "capitalize" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Please Select"
                  variant="outlined"
                  required
                  title=""
                  style={{ background: "#fff" }}
                />
              )}
            />
          </div >
        </div >
        {
          this.state.pageId === "orgAddress" && (
            <div className="row mt-3">
              <div className="col-md-6">
                <label className="form-label" htmlFor="multiStepsEmail">
                  Time Zone*
                </label>
                <Autocomplete
                  id="size-small-outlined"
                  size="small"
                  fullWidth
                  disableClearable
                  ListboxProps={{
                    className: "custom-listbox",
                  }}
                  options={this.timeZoneListArray}
                  value={this.state.orgTimeZone}
                  getOptionLabel={(option) => option.displayText}
                  defaultValue={this.state.timeZone}
                  onChange={(event, value) => {
                    this.handleTimeZoneChange(value);
                  }}
                  inputprops={{ style: { textTransform: "capitalize" } }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Please Select"
                      variant="outlined"
                      size="small"
                      className="textField"
                      required
                      title=""
                      style={{ background: "#fff" }}
                    />
                  )}
                />
              </div>
            </div>
          )
        }
      </>
    );
  }

  viewAddress() {
    let stateName =
      null !== this.state.state && undefined !== this.state.state
        ? this.state.state.code
        : "";
    let countryName =
      null !== this.state.country && undefined !== this.state.country
        ? this.state.country.isocode
        : "";
    let statecountryName = stateName + "," + countryName;
    return (
      <>
        <Row md={12} className="addressRow">
          <Col>
            <Label style={{ color: "#000" }}>
              {undefined !== this.state.line ? this.state.line : ""}
            </Label>
          </Col>
        </Row>
        <Row className="addressRow">
          <Col>
            <Label style={{ color: "#000" }}>
              {undefined !== this.state.city
                ? Utils.toCamelCase(this.state.city)
                : ""}
            </Label>
          </Col>
        </Row>
        <Row className="addressRow">
          <Col>
            <Label style={{ color: "#000" }}>{statecountryName} </Label>
          </Col>
        </Row>
        <Row className="addressRow">
          <Col>
            <Label style={{ color: "#000" }}>{this.state.zipCode}</Label>
          </Col>
        </Row>
      </>
    );
  }

  createAddress() {
    return (
      <>
        <div className="row">
          <div className="col-md-12" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-companyName">
              Street Address
            </label>
            <input
              type="text"
              autoComplete="off"
              id="multiStepsFirstName"
              name="multiStepsFirstName"
              className="form-control"
              onChange={this.handleLine1Change.bind(this)}
              value={this.state.line}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              City*
            </label>
            <input
              required
              title=""
              type="text"
              autoComplete="off"
              id="multiStepsFirstName"
              name="multiStepsFirstName"
              className="form-control"
              value={this.state.city}
              onChange={this.handleCityChange.bind(this)}
              onBlur={() => {
                this.props.onChange(this.state);
              }}
            />
          </div>
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="multiStepsState">
              State/Province/Region*
            </label>
            <Autocomplete
              id="size-small-outlined"
              size="small"
              fullWidth
              disableClearable
              ListboxProps={{
                className: "custom-listbox",
              }}
              options={this.stateListArray}
              value={this.state.state}
              getOptionLabel={(option) => option.namecode}
              defaultValue={this.state.state}
              onChange={(event, value) => {
                this.handleStateChange(value);
              }}
              inputprops={{ style: { textTransform: "capitalize" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Please Select"
                  variant="outlined"
                  size="small"
                  className="textField"
                  required
                  title=""
                  style={{ background: "#fff" }}
                />
              )}
            />
          </div >
        </div >
        <div className="row mt-3">
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              Zip/Postal Code*
            </label>
            <input
              type="text"
              autoComplete="off"
              id="multiStepsLastName"
              className="form-control"
              value={this.state.zipCode}
              onChange={this.handlePinCodeChange.bind(this)}
              inputprops={{ maxLength: 16 }}
              onBlur={() => {
                this.props.onChange(this.state);
              }}
              name="zipCode"
            />
            {this.state.zipCodeErrorMessageText && (
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                }}
              >
                {this.state.zipCodeErrorMessageText}
              </p>
            )}
          </div>
          <div className="col-md-6" id="assetFormLabel">
            <label className="form-label" htmlFor="collapsible-fullname">
              Country
              *
            </label>
            <Autocomplete
              id="size-small-outlined"
              size="small"
              fullWidth
              disableClearable
              autoComplete="off"
              ListboxProps={{
                className: "custom-listbox",
              }}
              options={this.countryListArray}
              value={this.state.country}
              defaultValue={this.state.select}
              getOptionLabel={(option) => option.namecode}
              onChange={(event, value) => {
                this.handleCountryChange(value);
              }}
              inputprops={{ style: { textTransform: "capitalize" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Please Select"
                  variant="outlined"
                  required
                  title=""
                  style={{ background: "#fff" }}
                />
              )}
            />
          </div >
          {
            this.state.pageId === "orgAddress" && (
              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    Time Zone*
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.timeZoneListArray}
                    value={this.state.orgTimeZone}
                    getOptionLabel={(option) => option.displayText}
                    defaultValue={this.state.timeZone}
                    onChange={(event, value) => {
                      this.handleTimeZoneChange(value);
                    }}
                    inputprops={{ style: { textTransform: "capitalize" } }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="textField"
                        required
                        title=""
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              </div>
            )
          }
        </div >
      </>
    );
  }
}

export default AddressWithTimezone;
